<template>
  <div class="container-scroller">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth">
        <div class="row flex-grow">
          <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left p-5">
              <div class="brand-logo">
                <img src="../../assets/images/maxcess-logo.png" />
              </div>
              <h4>Forgot Your Password?</h4>

              <label
                class="form-check-label text-muted"
                style="font-size: 0.8rem"
                >Enter your registered email to verify your account.
              </label>
              <BForm class="mt-3">
                <div class="form-group">
                  <BFormInput
                    id="inline-form-input-name"
                    v-model="usr_email"
                    class="form-control form-control-lg"
                    placeholder="Email"
                    :state="is_valid_usr_email"
                    aria-describedby="input_error_usr_email"
                  />
                  <BFormInvalidFeedback id="input_error_usr_email"
                    >{{ str_email_validation_msg }}
                  </BFormInvalidFeedback>
                </div>
              </BForm>

              <div class="mt-3">
                <a
                  class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn"
                  @click="sendOTP"
                  >Send OTP</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useAuthStore } from "@/store/auth_store";
import axios from "axios";
import router from "@/router";
// const email_regex = /^[A-Za-z0-9._%+-]+@maxcessintl\.(com|eu)$/;
import { toast } from "vue3-toastify";
import { useLoading } from "vue-loading-overlay";
import { email_regex } from "@/main";

const usr_email = ref(null);
const str_email_validation_msg = ref(null);
const is_valid_usr_email = ref(null);
const auth_store = useAuthStore();
const $loading = useLoading();

const sendOTP = () => {
  if (usr_email.value == null || usr_email.value == "") {
    is_valid_usr_email.value = false;
    str_email_validation_msg.value = "Enter Email";
  } else if (!email_regex.test(usr_email.value)) {
    is_valid_usr_email.value = false;
    str_email_validation_msg.value = "Enter valid Email";
  } else {
    is_valid_usr_email.value = true;
  }

  if (is_valid_usr_email.value == true) {
    const loader = $loading.show({});
    //send otp functionality
    axios
      .post("/generate_otp_for_forgot_pass?usr_email=" + usr_email.value)
      .then((res) => {
        loader.hide();
        auth_store.reset_pass_user = res.data.user;
        router.push({ name: "verify-otp" });
      })
      .catch((err) => {
        loader.hide();
        toast(err.response.data.detail, {
          autoClose: 2000,
          theme: "colored",
          type: "error",
          position: "bottom-left",
          dangerouslyHTMLString: true,
        });
      });
  } else return;
};
</script>
